/**
 * Shared simulation constants live here (not in builders.ts) to break a
 * circular dependency: builders imports investmentWaterfall, and
 * investmentWaterfall needs IRA / return constants. Inlining them in
 * builders caused module-init NaNs (especially the age-50+ IRA catch-up
 * limit) when the cycle loaded builders first.
 */
export const MAX_SIMULATION_MONTHS = 360;
export const DEPOSIT_APY_PERCENT = 4.0;
export const INVESTMENT_RETURN_PERCENT = 8.0;
export const HIGH_INTEREST_THRESHOLD = 0.1;
/** IRA annual contribution limit — $7,500 (tax year 2026). */
export const IRA_ANNUAL_LIMIT_CENTS = 750_000;
